import React from 'react'
import DashboardPanel from './dashboardPanel'
import 'moment-range'

const DashboardCell = props => {
  const { date, visits, width, cellContentFn, isToday, roomTransfer } = props

  return (
    <div
      className={`dashboard-date ${isToday ? 'dashboard-date-today' : ''}`}
      style={{ width: width }}
      key={date.date()}
    >
      {cellContentFn(date)}
      {visits.map(visit => (
        <DashboardPanel
          key={visit.id}
          date={date}
          visit={visit}
          roomTransfer={roomTransfer}
        />
      ))}
    </div>
  )
}

export default DashboardCell



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboardCell.js